import { Injectable } from '@angular/core'

@Injectable()
export class DebounceService {
    public debounce(func, timeout = 300){
        let triggerF = func;
        return (...args) => {
          setTimeout(() => { triggerF.apply(this, args); }, timeout);
        };
      }
}
